import { IAuthorizedAccount } from "@wingspanhq/users";

export const selectorAccessibleMemberEmail = (account: IAuthorizedAccount) => {
  return (
    account.accessibleMember.user.email || account.accessibleUser.email || ""
  );
};